import {EagleApiInterface, EagleModuleApiInterface} from 'kernel/api/api'

export default (api: EagleApiInterface) => {
  api.collection.pageCategoryApi = <EagleModuleApiInterface>{
    create: (type: string, id: string, data: AnyObject) => api.request({
      url: `/api/admin/page-category/${type}/${id}`,
      type: 'post',
      params: data,
    }),
    update: (id: string, data: AnyObject) => api.request({
      url: `/api/admin/page-category/${id}/update`,
      type: 'put',
      params: data,
    }),
    tree: (type: string) => api.request({
      url: `/api/admin/page-category/tree/${type}`,
      type: 'get',
    }),
    flatTree: (type: string) => api.request({
      url: `/api/admin/page-category/flat-tree/${type}`,
      type: 'get',
    }),
    move: (from: string, to: string, mode: 'before'|'after'|'inside') => api.request({
      url: `/api/admin/page-category/move`,
      type: 'put',
      params: {
        from,
        to,
        mode,
      }
    }),
    delete: (id: string) => api.request({
      url: `/api/admin/page-category/${id}`,
      type: 'delete',
    }),
  }

  api.collection.pageApi = <EagleModuleApiInterface>{
    roles: () => api.request({
      url: `/api/admin/page/roles`,
      type: 'get',
    }),
    read: (id: string) => api.request({
      url: `/api/admin/page/${id}`,
      type: 'get',
    }),
    index: (params = {}) => api.request({
      url: `/api/admin/page/index`,
      type: 'get',
      params,
    }),
    create: (params = {}) => api.request({
      url: `/api/admin/page`,
      type: 'post',
      params,
    }),
    update: (id: string, params = {}) => api.request({
      url: `/api/admin/page/${id}/update`,
      type: 'put',
      params,
    }),
    patch: (id: string, column: string, value: any) => api.request({
      url: `/api/admin/page/${id}`,
      type: 'patch',
      params: {
        column,
        value,
      },
    }),
    delete: (id: string) => api.request({
      url: `/api/admin/page/${id}`,
      type: 'delete',
    }),
    batch: (targets: string[], column: string, value: any) => api.request({
      url: `/api/admin/page/batch`,
      type: 'patch',
      params: {
        ids: targets,
        column,
        value,
      },
    }),
    batchDelete: (targets: string[]) => api.request({
      url: `/api/admin/page/batch`,
      type: 'delete',
      params: { ids: targets },
    }),
  }
}
